<app-nav-bar></app-nav-bar>
<div id="main">
  <div class="fzf">
    <h1>Oops. 404'd!</h1>
    <p>The page you are looking for does not exist</p>
    <a [routerLink]="['/home']" href="#" class="btn" data-wipe="Take Me Home"
      >Take Me Home</a
    >
  </div>
</div>
